import persistReducer from "redux-persist/lib/persistReducer";
import storage from "redux-persist/lib/storage";
import { CoupanCityConstant } from "./CoupanCityConstant";

const initialState = {
  CoupanCityList: [],
  CoupanList: {
    isLoading: false,
  },

  AddCoupanModel: [{}],
  CoupanModels: {
    isLoading: true,
  },
  CoupancityDeleteList: [],
  cityDelate: {
    isLoading: true,
  },
  ChargingNetworkDeleteList: [],
  NetworkDelate: {
    isLoading: true,
  },
  SelectCouponCityListdata: [],
  SelectCouponCityModelloading: {
    isLoading: false,
  },
  SelectChargingNetworkListdata: [],
  SelectChargingModelloading: {
    isLoading: false,
  },
};

export const CoupanCityReducer = persistReducer(
  {
    storage,
    key: "CoupanCity",
    whitelist: [" CoupancityTable"],
  },

  (state = initialState, { type, payload }) => {
    switch (type) {
      case CoupanCityConstant.COUPAN_CITY_REQUEST: {

        return {
          ...state,
          CoupanCityList: [],
          CoupanList: {
            isLoading: true,
          },
        };
      }

      case CoupanCityConstant.COUPAN_CITY_RESPONSE: {
        return {
          ...state,
          CoupanCityList: payload,
          CoupanList: {
            isLoading: false,
          },
        };
      }

      case CoupanCityConstant.POST_ADD_COUPAN_MODEL_REQUEST: {

        return {
          ...state,
          AddCoupanModel: [],
          CoupanModels: {
            isLoading: true,
          },
        };
      }

      case CoupanCityConstant.POST_ADD_COUPAN_MODEL_RESPONSE: {
        return {
          ...state,
          AddCoupanModel: payload,
          CoupanModels: {
            isLoading: false,
          },
        };
      }

      //delete
      case CoupanCityConstant.COUPAN_CITY_DELETE_REQUEST: {
        return {
          ...state,
          CoupancityDeleteList: [],
          cityDelate: {
            isLoading: true,
          },
        };
      }
      case CoupanCityConstant.COUPAN_CITY_DELETE_RESPONSE: {
        return {
          ...state,
          CoupancityDeleteList: payload,

          cityDelate: {
            isLoading: false,
          },
        };
      }

      case CoupanCityConstant.CHARGING_NETWORK_DELETE_REQUEST: {
        return {
          ...state,
          ChargingNetworkDeleteList: [],
          NetworkDelate: {
            isLoading: true,
          },
        };
      }
      case CoupanCityConstant.CHARGING_NETWORK_DELETE_RESPONSE: {
        return {
          ...state,
          ChargingNetworkDeleteList: payload,

          NetworkDelate: {
            isLoading: false,
          },
        };
      }

      case CoupanCityConstant.GET_SELECT_COUPON_CITY_REQUEST: {

        return {
          ...state,
          SelectCouponCityListdata: [],
          SelectCouponCityModelloading: {
            isLoading: true,
          },
        };
      }

      case CoupanCityConstant.GET_SELECT_COUPON_CITY_RESPONSE: {
        return {
          ...state,
          SelectCouponCityListdata: payload,
          SelectCouponCityModelloading: {
            isLoading: false,
          },
        };
      }

      // select charging Network

      case CoupanCityConstant.GET_SELECT_CHARGING_NETWORK_REQUEST: {
        return {
          ...state,
          SelectChargingNetworkListdata: [],
          SelectChargingModelloading: {
            isLoading: true,
          },
        };
      }

      case CoupanCityConstant.GET_SELECT_CHARGING_NETWORK_RESPONSE: {
        return {
          ...state,
          SelectChargingNetworkListdata: payload,
          SelectChargingModelloading: {
            isLoading: false,
          },
        };
      }

      default:
        return state;
    }
  }
);
